<igx-input-group>
  <input
    igxInput
    type="tel"
    [minlength]="8"
    [maxlength]="15"
    [ngModel]="innerModel"
    (ngModelChange)="onNgModelChange($event)"
    [id]="_id"
    [name]="_id"
    [required]="_required"
    autocomplete="off"
    [readonly]="_disabled"
    (onTouched)="passOnTouched($event)"

  />
  <label igxLabel [for]="_id">{{ _label }}</label>
</igx-input-group>
